const DebugIntegrations = () => import('@/views/controller/debug/Integrations')

export default [
    { path: 'debug', name: 'controller.debug', component: DebugIntegrations, meta: { title: 'Debug de integrações', permission: 19 } },
]